import axios from "services/api";
import Flex from 'components/common/Flex';
import { widgetRegister } from 'data/widgets';
import { API3_HOST } from 'helpers/urlHelper';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, ListGroup, Modal } from 'react-bootstrap';

/***
 * Modal for adding a new widget to a dashboard. Widgets are defined in a register and are linked to actual components.
 */

// Return array of list items for each widget.
function GetListItems(props) {
  var ret = [];
  for (let i = 0; i < widgetRegister.length; i++) {
    ret.push(
      <ListGroup.Item
        className="p-1 p-sm-2"
        as={Button}
        onClick={() => {
          props.onClick(i);
        }}
        action
        to=""
      >
        <Flex justifyContent="between">
          <h5 className="mb-1">{widgetRegister[i].name}</h5>
        </Flex>
        <p className="mb-1">{widgetRegister[i].description}</p>
      </ListGroup.Item>
    );
  }
  return ret;
}

export default function AddWidgetModal(props) {
  // Add widget to dashboard and hide the modal
  const addWidget = id => {
    let widget = widgetRegister[id];
    let requestBody = {
      dashboardId: props.dashboardId,
      typeId: id,
      name: `${widget.name} Widget`
    };
    axios({
      method: 'post',
      url: `${API3_HOST}/dashboard/widget/`,
      data: requestBody
    })
      .then(() => {
        props.onHide();
      })
      .catch(err => {
        console.log('AddWidgetModal Error: ', err);
      });
  };

  // Normal modal rendering stuff
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Add Widget</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0"></Modal.Body>
      <ListGroup>
        <GetListItems onClick={addWidget}></GetListItems>
      </ListGroup>
    </Modal>
  );
}

AddWidgetModal.propTypes = {
  dashboardId: PropTypes.int,
  show: PropTypes.bool,
  onHide: PropTypes.func
};
